import BaseModal from 'components/BaseModal'
import { isFunction } from 'lodash'
import React from 'react'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

import OrganizationModalHeader from '../OrganizationModalHeader'
import SectionLoading from '../SectionLoading'
import OrganizationDetailsEdit from './components/OrganizationDetailsEdit'
import OrganizationDetailsView from './components/OrganizationDetailsView'
import { User } from '../../../../entities-next/user'

class OrganizationDetailsModal extends React.PureComponent<OrganizationDetailsModalProps> {
  render() {
    const { show, isInEditMode, isLoading, isSubmitting, deal, user, organization, footer, onClose } = this.props

    const modalTitle = <OrganizationModalHeader deal={deal} organization={organization || undefined} />

    const modalFooter = isFunction(footer) ? footer({ organization, deal, user, isInEditMode, isSubmitting }) : footer

    return (
      <BaseModal
        footer={modalFooter}
        onClose={onClose}
        open={show}
        title={modalTitle}
        fullWidth={true}
        maxWidth={false}
      >
        {isLoading ? (
          <SectionLoading />
        ) : isInEditMode ? (
          <OrganizationDetailsEdit organization={organization!} />
        ) : (
          <OrganizationDetailsView />
        )}
      </BaseModal>
    )
  }
}

export type OrganizationDetailsModalProps = {
  show?: boolean
  isInEditMode?: boolean
  isSubmitting?: boolean
  isLoading?: boolean
  deal?: Deal
  user?: User
  organization?: Organization
  footer?: React.ReactNode
  onClose?: () => void
}

export type OrganizationDetailsModalFooter = (args: {
  organization: Organization
  deal?: Deal
  user?: User
  isInEditMode?: boolean
  isSubmitting?: boolean
}) => React.ReactNode | React.ReactNode

export default OrganizationDetailsModal
